import React from 'react'
import PropTypes from 'prop-types'
import css from './style.css'

const Header = props => (
  <div className={css.container}>
    <h1 className={css.header}>
      {props.children}
    </h1>
    <div className={css.subtitle}>{props.subtitle}</div>
  </div>
)

Header.propTypes = {
  subtitle: PropTypes.string
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header/index.js